import { Component } from 'react'
import { connect } from 'react-redux'
import { NavigationHOC, GroupContentHOC } from 'hocs'
import TrendingTopics from 'components/TrendingTopics'
import { selectTopicsFetching } from './selectors'
import { fetchTopics } from './actions'
import { selectCurrentPhoneId } from '../App/selectors'

class TrendingTopicsContainer extends Component {
  componentDidMount() {
    if (this.props.faqs.length === 0 && this.props.tutorials.length === 0) {
      this.props.fetchTopics(this.props.currentDeviceId)
    }
  }

  render() {
    return <TrendingTopics {...this.props} />
  }
}

const mapStateToProps = (state) => ({
  currentDeviceId: selectCurrentPhoneId(state),
  isFetching: selectTopicsFetching(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchTopics: (deviceId) => dispatch(fetchTopics.request(deviceId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  GroupContentHOC(NavigationHOC(TrendingTopicsContainer), {
    stateName: 'trending'
  })
)
